import theme from "@/constants/theme";
import React from "react";

interface TabOption {
  id: number;
  label: string;
}

interface TabsProps {
  tabs: TabOption[];
  currentTab: number;
  setCurrentTab: React.Dispatch<React.SetStateAction<number>>;
  onChange?: (id: number) => void;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  currentTab,
  setCurrentTab,
  onChange,
}) => {
  const containerStyle: React.CSSProperties = {
    display: "flex",
  };

  const tabStyle = (isActive: boolean): React.CSSProperties => ({
    padding: "10px 20px",
    cursor: "pointer",
    borderBottom: isActive
      ? `2px solid ${theme.colors.primary}`
      : "2px solid transparent",
    color: isActive ? theme.colors.primary : theme.colors.text.caption,
    // backgroundColor: isActive ? "#f9f9f9" : "transparent",
    transition: "all 0.3s ease",
  });

  const handleTabClick = (id: number) => {
    setCurrentTab(id);
    if (onChange) {
      onChange(id);
    }
  };

  return (
    <div style={containerStyle}>
      {tabs.map((tab) => (
        <div
          key={tab.id}
          style={tabStyle(currentTab === tab.id)}
          onClick={() => handleTabClick(tab.id)}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export default Tabs;
